
import useHooks from '@/hooks/index.hooks';
import useScoreRankingHooks, { TableData } from '@/hooks/scoreRanking.hooks';
import { Page } from '@/interface/index.interface';
import { cloneDeep } from '@/lib';
import { definitions } from '@/types/api';
import { Pagination, Table, Tabs } from 'ant-design-vue';
import {
  defineComponent, reactive, toRefs, computed,
} from 'vue';
import uiTabFrameworkVue from '@/components/student/uiTabFramework.vue';
import useAnalysisHooks, { getJobStatus, TableDataAnalysis } from '@/hooks/analysis.hooks';
import { useRouter } from 'vue-router';
import { PageAnalysis } from '@/interface/analysis.interface';
import { caseModuleArr } from '@/interface/case.interface';
import useReportHooks from '@/hooks/report.hooks';

export default defineComponent({
  components: {
    aTable: Table,
    aPagination: Pagination,
    uiTabFrameworkVue,
    aTabs: Tabs,
    aTabPane: Tabs.TabPane,
  },
  setup() {
    const router = useRouter();
    const { getPageOption } = useHooks();
    const analysisHooks = useAnalysisHooks();
    const reportHooks = useReportHooks();
    const scoreRankingHooks = useScoreRankingHooks();
    const tabsData = reactive({
      tabArr: ['案例分析', '成绩排名'],
      activeTab: '案例分析',
    });
    /** ============== */
    const tableData = reactive<Page & TableData>({
      tableList: [],
      tableLoading: false,
      columns: scoreRankingHooks.stuScoreRankingColumns(),
      /** */
      pageNo: 1,
      pageSize: 10,
      total: 0,
      pageOption: cloneDeep(getPageOption),
    });
    /** 查询列表 */
    const getList = async () => {
      tableData.tableLoading = true;
      const { pageNo, pageSize } = tableData;
      const { list, total } = await scoreRankingHooks.listExperimentRanking({ pageNo, pageSize });
      Object.assign(tableData, {
        tableList: list, total, tableLoading: false,
      });
    };
    /** 表格属性 */
    const methodData = reactive({
      /** 跳转详情页 */
      gotoInfo: (record: definitions['Experiment']) => {
        reportHooks.currentReportDate.set(record.createTime || '');
        router.push({
          path: `/Student/reportInfo/${record.id}`,
        });
      },
      /** 禁用查看-学生状态 */
      stuStatus: computed(() => (record: definitions['ExperimentScorePersonnelResponse']) => {
        /** 只有实验结束才能看详情 */
        if (record.groupStatus === 2) return false;
        return true;
      }),
      /** 状态 */
      expStatus: computed(() => (record: definitions['ExperimentScoreResponse']) => {
        if (record.status === 0) return '未开始';
        if (record.status === 1) return '进行中';
        if (record.status === 2) return '已结束';
        return '';
      }),
    });
    const pageMethod = reactive({
      showSizeChange: (_: unknown, size: number) => {
        tableData.pageSize = size;
        tableData.pageNo = 1;
        getList();
      },
      pageChange: (page: number) => {
        tableData.pageNo = page;
        getList();
      },
    });
    /** ============== TableDataAnalysis Analysis */
    const tableDataAnalysis = reactive<PageAnalysis & TableDataAnalysis>({
      tableListAnalysis: [],
      tableLoadingAnalysis: false,
      columnsAnalysis: cloneDeep(analysisHooks.analysisColumns),
      /** */
      pageNoAnalysis: 1,
      pageSizeAnalysis: 10,
      totalAnalysis: 0,
      pageOptionAnalysis: cloneDeep(getPageOption),
    });
    /** 查询列表 */
    const getListAnalysis = async () => {
      tableDataAnalysis.tableLoadingAnalysis = true;
      const { pageNoAnalysis, pageSizeAnalysis } = tableDataAnalysis;
      const { list, total } = await analysisHooks.listAssignHomeworkList({ pageNo: pageNoAnalysis, pageSize: pageSizeAnalysis, assignStatus: 2 });
      Object.assign(tableDataAnalysis, {
        tableListAnalysis: list, totalAnalysis: total, tableLoadingAnalysis: false,
      });
    };
    const pageMethodAnalysis = reactive({
      showSizeChangeAnalysis: (_: unknown, size: number) => {
        tableDataAnalysis.pageSizeAnalysis = size;
        tableDataAnalysis.pageNoAnalysis = 1;
        getListAnalysis();
      },
      pageChangeAnalysis: (page: number) => {
        tableDataAnalysis.pageNoAnalysis = page;
        getListAnalysis();
      },
    });
    const tableMethodAnalysis = reactive({
      /** 是否可以点击查看 */
      isRanking: computed(() => (record: definitions['AssignHomework']) => {
        // -1 学生没做
        if (record.ranking === -1) return false;
        return true;
      }),
      /** 跳转详情页 */
      gotoInfoAnalysis: (record: definitions['AssignHomework']) => {
        console.log(record, router);
        router.push({
          path: '/Student/analysisAnswer',
          query: {
            view: 'see', // preview,see,submit
            jobId: record.assignmentId, // jobId这是教师端的作业id
            assignmentId: record.id, // 这是分配表的id
            assignmentModel: record.assignmentModel, // 分配模式
          },
        });
      },
    });

    getList();
    getListAnalysis();
    return {
      ...toRefs(tabsData),
      /**  */
      ...toRefs(tableData),
      ...toRefs(pageMethod),
      ...toRefs(methodData),
      /**  */
      ...toRefs(tableDataAnalysis),
      ...toRefs(pageMethodAnalysis),
      ...toRefs(tableMethodAnalysis),
      /** */
      getJobStatus,
      caseModuleArr,
    };
  },
});
